import dayjs from "dayjs";
import { parseDateString } from "modules/Expenses/validations/getOnSubmitValidationSchema";

export const toExpenseCostLineSavePayloadTransformer = ({
  costLineData,
  formData: { cost_type, currency_code, vat, ...formData },
  isDirty,
  userRole,
  costType,
}) => {
  return {
    isValid: true,
    formData: {
      ...formData,
      id: costLineData?.id,
      cost_line_id: costLineData?.id,
      unique_id:
        costLineData?.unique_id ?? `initial${Math.random()}`.slice(0, 20),
      currency_code: currency_code?.value,
      user_role: userRole,
      // send empty strings as null values to reset cost_type, null values can't be sent with formData
      // TODO append empty strings to null values in toFormData function, check if all requests work as expected
      cost_type_id: cost_type?.value?.id ?? "",
      vat_id: vat?.value,
      vehicle_id: formData?.vehicle_id,
      lineType: "expense",
      // sending "1" | "0" instead of Boolean 🤡 because cost lines are sent in form data which accepts only string format
      // but backend is automatically parses "0" | "1" fields to boolean
      // TODO remove this workaround after attachments unification which is a blocker forcing to send data in form data format
      accommodation_required_line: formData?.accommodation_required_line
        ? "1"
        : "0",
      is_job_related: formData?.is_job_related ? "1" : "0",
      company_card_payment: formData?.company_card_payment ? "1" : "0",
      purchase_date:
        !costLineData?.purchase_date && costType?.value?.subtype === "Mileage"
          ? parseDateString(dayjs())
          : formData?.purchase_date,
      isDirty: isDirty || costLineData?.id.toString().startsWith("initial"),
    },
  };
};
